import * as React from 'react';
import * as request from 'superagent';
import {withStyles,
  WithStyles,
  StyleRules,
  ClassNameMap
} from '@mui/styles';
import {Theme} from '@mui/styles';
import LoadingView from '~common/components/loading-view';
import {Typography} from '@mui/material';
import {APIError} from '~common/lib/types';
import URLManager from '~common/lib/url-manager';
import classNames from 'classnames';
import DefinitionSection from '~common/form/definition-section';
import {Definition} from '~common/lib/types';
import {setValueAtPath} from '~common/form/helper';
import Renderers from '~common/lib/renderers';

const styles = (theme: Theme): StyleRules => ({
  taskCard: {
    width: '100%',
    background: theme.palette.background.paper,
    border: '1px solid #ccc',
    minHeight: 200
  },
  caption: {
    textAlign: 'center',
    borderBottom: '1px solid #ccc',
    padding: 10
  },
  cardContent: {
    margin: '10px 15px 10px 15px'
  },
  aggregationContent: {
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: 'center',
    minHeight: 120,
    fontSize: '3.0rem',
    cursor: 'pointer'
  },
  templateContent: {
    minHeight: 120
  },
  cardContentEven: {
    margin: '10px 15px 10px 15px',
    display: 'flex',
    justifyContent: 'space-around'
  },
  cardActions: {
    padding: 5
  }
});

interface Props {
  history:any;
  id: number;
  caption: string;
  renderers: any;
  element: any;

  chromeless?: boolean;
  //results is the results that were showing when the card was created.  This is useful for capturing attributes like ggregationAttributes.
  results: any;
}

type State = {
  status: 'loading' | 'ready';
  configData: any;
  form: any;
  formData: any;
  policyMessages: Array<any>;
  error?: any;
};

class AggregationEditor extends React.Component<
  Props & WithStyles<keyof typeof styles>,
  State
> {
  
  static register = () => {
    if(!Renderers.find("AggregationConfigRenderer")){
      Renderers.register("AggregationConfigRenderer", AggregationEditor)
    }
  }

  constructor(props: Props & WithStyles<keyof typeof styles>) {
    super(props, {});
    this.state = {
      status: 'loading',
      configData: props.element,
      formData: {
        method: "count",
      },
      form: this.deriveForm(props) 
    };
    
  }

  // this function uses the inbound results information to ascertain the form options that should be available.
  deriveForm = (props: Props & WithStyles<keyof typeof styles>) => {
    const {element, elementType} = props
    const {results} = this.props  

    let form = aggregationForm
    
    // After we mount the compo
    if(results && results.aggregationAttributes){
    
      //To limit to `count type only` if the results form has no appropriate numerif field to be the aggregationAttribute
      if(!results.aggregationAttributes.aggregation || results.aggregationAttributes.aggregation.length==0){
        form.predefined[1].options = [
          {
            label: 'Count',
            value: 'count'
          },
        ]
      } else {
        // Using the index since the form is statically defined below.
        form.predefined[2].options = results.aggregationAttributes.aggregation
      }
  
      

      if(!results.aggregationAttributes.grouping || results.aggregationAttributes.grouping.length==0){
        // if no grouping options were supplied
        form.predefined[3].mode = "Hidden"
      }
      else {
        form.predefined[3].options = results.aggregationAttributes.grouping
      }
    } else {
      // If no attributes were proveded, one will be limited to counts
        form.predefined[1].options = [
          {
            label: 'Count',
            value: 'count'
          },
          {
            label: 'Sum',
            value: 'sum'
          }
        ]
    }

    return form
    
  }

  // handleChangeAtPath is used to ferry changes from owned components upstream
  handleChangeAtPath = (path: string, value: any) => {
    const {element, elementType} = this.props
    let {configData, form, formData} = this.state;

    
    let svpResp = setValueAtPath(path, formData, value);

    formData = svpResp.data

    if (svpResp.err) {
      console.error(svpResp.err);
    }

    this.setState({configData, form, formData}, ()=>{
      configData.title = formData.title
      // For ease of development and user interface, we have flattened and comingled the element data and the aggregation opts, so this is our chance to update the configData wiht that data.
      if(!configData.fulfillmentCriteria) {
        configData.fulfillmentCriteria = {}
      }
      if(!configData.fulfillmentCriteria.aggregationOpts) {
        configData.fulfillmentCriteria.aggregationOpts = {}
      }
        
      configData.fulfillmentCriteria.aggregationOpts.method = formData.method
      configData.fulfillmentCriteria.aggregationOpts.groupingAttribute = formData.groupingAttribute
       

      if(formData.method == "count"){
        configData.fulfillmentCriteria.aggregationOpts.aggregationAttribute = '*'
      } else {
        configData.fulfillmentCriteria.aggregationOpts.aggregationAttribute = formData.aggregationAttribute
      }


      if(this.props.onConfigChange){
        this.props.onConfigChange(configData)
      }
      this.clearMessagesAtPath(path)
    });

  };

  // clearMessagesAtPath helps to show user progress by clearing messages for a path as the user updates the value at the path
  clearMessagesAtPath = (path:string) => {
    const {policyMessages} = this.state
    if(policyMessages && policyMessages.length>0){
      const pm = policyMessages.reduce((acc, m)=>{
        let mp = m.path 
        if(mp.indexOf("/")==0){
          mp = mp.substring(1)
        }

        let op = path 
        if(op.indexOf("/")==0){
          op = op.substring(1)
        }

        if (mp != op) {
          acc.push(m)
        }

        return acc
      }, [])

      this.setState({policyMessages:pm})
    }
  }

  render() {
    const {classes}: {classes: ClassNameMap} = this.props;
    const {chromeless} = this.props;
    const {status, configData, policyMessages, form, formData} = this.state;

    // Make sure title is still centered after icon placment
    return (
      <div>
        <DefinitionSection
          data={formData}
          definition={new Definition(form)}
          path={''}
          policyMessages={policyMessages}
          onChangeAtPath={this.handleChangeAtPath}
          gridSpacing={3}
          suppressTitle={true}
        />
      </div>
    );
  }
}

var aggregationForm: any = {
  key: 'aggregationForm',
  title: 'Aggregation Form',
  predefined: [
    {
      gridAttributes: {
        lg: 12,
        md: 12,
        sm: 12,
        xl: 12,
        xs: 12
      },
      key: 'title',
      mode: 'Required',
      title: 'Card Title',
      type: 'Text'
    },
    {
      gridAttributes: {
        lg: 12,
        md: 12,
        sm: 12,
        xl: 12,
        xs: 12
      },
      key: 'method',
      mode: 'Required',
      options: [
        {
          label: 'Count',
          value: 'count'
        },
        {
          label: 'Sum',
          value: 'sum'
        },
        {
          label: 'Min',
          value: 'min'
        },
        {
          label: 'Max',
          value: 'max'
        }
      ],
      title: 'Method',
      type: 'Text'
    },
    {
      conditionalAttributes: [
        {
          attributeName: 'mode',
          attributeValue: 'Hidden',
          operator: '==',
          path: 'method',
          value: 'count'
        }
      ],
      gridAttributes: {
        lg: 12,
        md: 12,
        sm: 12,
        xl: 12,
        xs: 12
      },
      key: 'aggregationAttribute',
      mode: 'Required',
      title: 'Attribute',
      type: 'Text'
    },
    {
      gridAttributes: {
        lg: 12,
        md: 12,
        sm: 12,
        xl: 12,
        xs: 12
      },
      key: 'groupingAttribute',
      mode: 'Optional',
      title: 'Group By',
      type: 'Text'
    }
  ],
  user: [],
  definitions: []
};

export default withStyles(styles)(AggregationEditor);
